import React, { useState, useContext, useEffect } from 'react';
import css from './CarRateForm.module.css';
import Star from "../../../../assets/Icon/Star"; 
import { AppContext } from "../../../../providers/appProvider";
import { useCar } from '../../../../hooks/useCar'; 
import { useFeedback } from '../../../../hooks/useFeedback.jsx'; 
import { useAuth } from '../../../../providers/authProvider';
import { useMessage } from '../../../../hooks/useMessage';

const CarRate = ({ id }) => {
    const { appState, app } = useContext(AppContext);
    const { messageService } = useMessage();
    const { carService } = useCar(-1);
    const { feedbackService } = useFeedback(-1);
    const [car, setCar] = useState(null);
    const [modalType, setModalType] = useState('add'); 
    const auth = useAuth();  

    const rateResetData = {
        id: 0,
        car_id: parseInt(id, 10),   
        is_satisfied: '',
        comment_satisfied: '',
        facebook: 0,
        instagram: 0,
        tiktok: 0,
        youtube: 0,
        google: 0,
        autowini: 0,
        recommendation: 0,
        recommendation_name: '',
        old_client: 0,
        outdoor_ad: 0,
        additional: '',
        last_user_id: parseInt(auth.session.id, 10),  
        updated_at: new Date(),  
    };

    
    const serviceResetData = {
        id:0,
        car_id: parseInt(id, 10),   
        service_is_satisfied: '',
        service_comment: '',
        poti_is_satisfied: '',
        poti_comment: '',
        service_additional: '',
        logistics_manager_is_satisfied: '',
        logistics_manager_comment: '',
        gpi_contacted_about_third_party_insurance: '',
        sent_message: 0,
        send_facebook: 0,
        send_google: 0,
        service_last_user_id: parseInt(auth.session.id, 10),  
        service_updated_at: new Date(new Date().getTime()),  
    }



    const [newRate, setNewRate] = useState(rateResetData);
    const [newService, setNewService] = useState(serviceResetData)
    const [oldRate, setOldRate] = useState(serviceResetData)
    const [oldService, setOldService] = useState(serviceResetData)
    const [validates, setValidates] = useState({});

    const validateRate = (item) => {
        const messages = {};

        if (item.is_satisfied !== 1 && item.is_satisfied !== 2) {
            messages.is_satisfied = { message: 'არჩევა სავალდებულოა', isValid: false };
        }
      
       
        if (item.comment_satisfied === '') {
            messages.comment_satisfied = { message: 'ჩაწერე კომენტარი', isValid: false };
        }
        if (!(item.facebook || item.instagram || item.tiktok || item.youtube || item.google || item.recommendation || item.old_client || item.autowini)) {
            messages.sourceCheck = { message: 'არჩევა სავალდებულოა', isValid: false };
        }
        const isValid = Object.keys(messages).length === 0;
        setValidates(messages);
        return isValid;  
    };


    const validateService = (item) => {
        const messages = {};
        
        if (item.service_is_satisfied !== 1 && item.service_is_satisfied !== 2) { 
            messages.service_is_satisfied = { message: 'არჩევა სავალდებულოა', isValid: false };
        }

        if (item.poti_is_satisfied !== 1 && item.poti_is_satisfied !== 2) { 
            messages.poti_is_satisfied = { message: 'არჩევა სავალდებულოა', isValid: false };
        }

        if (item.service_comment === '') {
            messages.service_comment = { message: 'ჩაწერე კომენტარი', isValid: false };
        }

        if (item.poti_comment === '') {
            messages.poti_comment = { message: 'ჩაწერე კომენტარი', isValid: false };
        }

        if (item.service_additional === '') {
            messages.service_additional = { message: 'ჩაწერე კომენტარი', isValid: false };
        }

        if (item.logistics_manager_is_satisfied !== 1 && item.logistics_manager_is_satisfied !== 2) { 
            messages.logistics_manager_is_satisfied = { message: 'არჩევა სავალდებულოა', isValid: false };
        }

        if (item.logistics_manager_comment === '') {
            messages.logistics_manager_comment = { message: 'ჩაწერე კომენტარი', isValid: false };
        }

        if (item.gpi_contacted_about_third_party_insurance !== 1 && item.gpi_contacted_about_third_party_insurance !== 2) { 
            messages.gpi_contacted_about_third_party_insurance = { message: 'არჩევა სავალდებულოა', isValid: false };
        }

        if (!(item.sent_message || item.send_google )) {
            messages.sent_message = { message: 'არჩევა სავალდებულოა', isValid: false };
        }
        
/*
        if (!(item.send_facebook || item.send_google )) {
            messages.sendLink = { message: 'არჩევა სავალდებულოა', isValid: false };
        }
  */      
        const isValid = Object.keys(messages).length === 0;
        setValidates(messages);
        return isValid;  
    };


    const initEditRate = (rate) => ({
        id: rate.id,
        car_id: rate.car_id,  
        is_satisfied: rate.is_satisfied,  
        comment_satisfied: rate.comment_satisfied,  
        facebook: rate.facebook,  
        instagram: rate.instagram,  
        tiktok: rate.tiktok,  
        youtube: rate.youtube,  
        google: rate.google,  
        autowini: rate.autowini,  
        recommendation: rate.recommendation,  
        recommendation_name: rate.recommendation_name,  
        old_client: rate.old_client,  
        outdoor_ad: rate.outdoor_ad,  
        additional: rate.additional,  
        last_user_id: rate.last_user_id,   
        updated_at: new Date(new Date().getTime()),  
    });

    const initEditService = (rate) => ({
        id: rate.id,
        car_id: rate.car_id,      
        service_is_satisfied: rate.service_is_satisfied,   
        service_comment: rate.service_comment,   
        poti_is_satisfied: rate.poti_is_satisfied,   
        poti_comment:  rate.poti_comment,   
        service_additional: rate.service_additional,   
        logistics_manager_is_satisfied: rate.logistics_manager_is_satisfied,   
        logistics_manager_comment: rate.logistics_manager_comment,   
        gpi_contacted_about_third_party_insurance: rate.gpi_contacted_about_third_party_insurance,   
        sent_message: rate.sent_message,   
        send_facebook: rate.send_facebook,   
        send_google: rate.send_google,   
        service_last_user_id: rate.service_last_user_id,   
        service_updated_at: new Date(new Date().getTime()),   
    });

    useEffect(() => {
        const fetchCar = async () => {
            try {
                const fetchedCar = await carService.getCarById(Number(id));
                if (fetchedCar) {
                    setCar(fetchedCar); 

                    const fetchRate = async () => {
                        try { 
                            const fetchedRate = await feedbackService.getFeedbackByCarId(Number(id));
                            if (fetchedRate) { 
                                setModalType('update');  
                                const editedRate = initEditRate(fetchedRate);
                                const editedService = initEditService(fetchedRate);
                                setNewRate(editedRate);
                                setNewService(editedService); 
                                setOldRate(fetchedRate); 
                                setOldService(fetchedRate); 
 

                            } else {
                                console.error("No car found with the given ID");
                            }
                        } catch (err) {
                            console.error("Error fetching the car:", err);
                        }
                    };

                    fetchRate(); 
 
                } else {
                    console.error("No car found with the given ID");
                }
            } catch (err) {
                console.error("Error fetching the car:", err);
            }
        };

        if (id) {
            fetchCar(); 
        }


  


    }, [id]);

 
 

    const saveHandleRate = () => {
        const isValidate = validateRate(newRate);
        if (isValidate) {
            const action = modalType === 'add' ? feedbackService.add : feedbackService.update;

            const rateJustNow = {
                ...newRate,
                last_user_id: parseInt(auth.session.id, 10),  
                updated_at: new Date(),   
            };

            action(rateJustNow).then(() => {


                const fetchRateUpdated = async () => {
                    try { 
                        const fetchedRate = await feedbackService.getFeedbackByCarId(Number(id));
                        if (fetchedRate) { 


                            setModalType('update');  
                            const editedRate = initEditRate(fetchedRate);
                            const editedService = initEditService(fetchedRate);
                            setNewRate(editedRate);
                            setNewService(editedService);

                            carService.updateFeedbackId(Number(id), Number(id))
                            .then(() => {  
                                console.log('წარმატებით განახლდა'); 
                            }).catch((error) => {
                                console.error(error);
                            });
 

                        } else {
                            console.error("No car found with the given ID");
                        }
                    } catch (err) {
                        console.error("Error fetching the car:", err);
                    }
                };

                fetchRateUpdated(); 


                
                app.setOk("წარმატებით განახლდა");
            }).catch((error) => {
                console.error("შეცდომა გამოვლინდა:", error);
            });
        }
    };
 

    const saveHandleService = () => {
        const isValidateServ = validateService(newService);
        if (isValidateServ) {
            const action = modalType === 'add' ? feedbackService.add : feedbackService.update;


            const serviceJustNow = {
                ...newService,
                service_last_user_id: parseInt(auth.session.id, 10),  
                service_updated_at: new Date(new Date().getTime()),          
            };

            action(serviceJustNow).then(() => {
 

                

                const fetchRateUpdated = async () => {
                    try { 
                        const fetchedRate = await feedbackService.getFeedbackByCarId(Number(id));
                        if (fetchedRate) { 
                            setModalType('update');  
                            const editedRate = initEditRate(fetchedRate);
                            const editedService = initEditService(fetchedRate);
                            setNewRate(editedRate);
                            setNewService(editedService);

                            carService.updateFeedbackServiceId(Number(id), Number(id))
                            .then(() => {  
                                console.log('წარმატებით განახლდა'); 
                            }).catch((error) => {
                                console.error(error);
                            });


                            if(oldService.sent_message === 0 && newService.sent_message === 1) {

                                const mobile = car.client.mobile;  
                                // const text = `მოგესალმებით! მადლობა, რომ ირჩევთ AUTO IMPORT GEORGIA-ს. შეაფასეთ ჩვენი მომსახურება Facebook-სა და Google-ზე და მიიღეთ 100$-იანი ფასდაკლება! `;
                                // const text2 = `${newService.send_facebook === 1 ? ' www.lo.ge/y90RX50\n' : ''}
                                // ${newService.send_google === 1 ? '  www.lo.ge/y90RX51\n' : ''}  `;
                                //const text3 = `ფასდაკლების მისაღებად გამოგვიგზავნეთ თქვენი შეფასების სქრინები. მიღებული ფასდაკლება შეგიძლიათ გამოიყენოთ თავად, ან აჩუქოთ სხვა ადამიანს. NO-94401`;
                                 
                                 const text = `მოგესალმებით! მადლობა, რომ ირჩევთ AUTO IMPORT GEORGIA-ს. შეაფასეთ ჩვენი მომსახურება Facebook-სა და Google-ზე და მიიღეთ 100$-იანი ფასდაკლება!\n\n${newService.send_facebook === 1 ? 'Facebook - https://www.facebook.com/autoimportgeorgia1/reviews \n' : ''}${newService.send_google === 1 ? 'Google - https://maps.app.goo.gl/MyLGz3anbtEjhpTF8 \n' : ''}\nფასდაკლების მისაღებად გამოგვიგზავნეთ თქვენი შეფასების სქრინები. მიღებული ფასდაკლება შეგიძლიათ გამოიყენოთ თავად, ან აჩუქოთ სხვა ადამიანს. NO-94401`;

                                
                                messageService.add(mobile, text);
                                //messageService.add(mobile, text2);
                               // messageService.add(mobile, text3);
                            }

    
                        } else {
                            console.error("No car found with the given ID");
                        }
                    } catch (err) {
                        console.error("Error fetching the car:", err);
                    }
                };

                fetchRateUpdated(); 
 
                app.setOk("წარმატებით განახლდა");
            }).catch((error) => {
                console.error("შეცდომა გამოვლინდა:", error);
            });
        }
    };


    const formatDate = (dateString) => {
 
        if (!dateString) {  
          return " ";
        } 
    
        const atDate = new Date(dateString);
        if (isNaN(atDate.getTime())) {
          return " ";
        } 
        if (dateString === "0001-01-01T00:00:00Z") {
          return " ";
      }
    
      
        atDate.setHours(atDate.getHours() - 4);
      
        const months = [
            "იან", "თებ", "მარ", "აპრ", "მაი", "ივნ",
            "ივლ", "აგვ", "სექ", "ოქტ", "ნოე", "დეკ"
        ]; 
        const day = atDate.getDate();
        const month = months[atDate.getMonth()]; 
        const year = atDate.getFullYear();
        const hours = atDate.getHours().toString().padStart(2, '0');
        const minutes = atDate.getMinutes().toString().padStart(2, '0');
         
        return `${day} ${month} ${year} `;
      };
    

    return (
        <div>
            <div className={css.modalHead}>
                <h3>
                    <span className={css.iconHead}><Star /></span> 
                    <div className={css.textHead}>
                        <div className={css.vinHead}>{car ? `${car.prod_year} ${car.maker.name} ${car.model.name}` : 'Loading...'}</div>
                        <div className={css.vinHead}>{car ? car.vin : 'Loading...'}</div> 
                    </div>
                </h3>
            </div>
            <div style={{display: 'flex', flexDirection: 'column'}}>
            <div className={css.bodyPage}>
                <div className={css.container}>
                    <h3 className={css.h3}>გაყიდვების მენეჯერის მომსახურების შეფასება და წყაროს განსაზღვრა </h3>
                    <div className={css.groupInput}>  
                        <div className={css.question}> რამდენად კმაყოფილია გაყიდვების მენეჯერი მომსახურებით?<span className={css.errorMsg}>*</span>
                            {validates.is_satisfied && <div className={css.errorMsg}>{validates.is_satisfied.message}</div>}
                        </div>
                        <div className={css.flexforCheck}> 
                            <div className={css.formCheck}> 
                                <input
                                    type="radio"
                                    id="satisfiedYes"  
                                    value={1}
                                    checked={newRate.is_satisfied === 1}
                                    onChange={() => setNewRate(prevState => ({ ...prevState, is_satisfied: 1 }))}
                                />
                                <label htmlFor="satisfiedYes">კმაყოფილია</label>
                            </div> 
                            <div className={css.formCheck}> 
                                <input
                                    type="radio"
                                    id="satisfiedNo"  
                                    value={2}
                                    checked={newRate.is_satisfied === 2}
                                    onChange={() => setNewRate(prevState => ({ ...prevState, is_satisfied: 2 }))}
                                />
                                <label htmlFor="satisfiedNo">არ არის კმაყოფილი</label>
                            </div>  
                        </div>
                    </div>                          
                    <div className={css.groupInput}>
                        <textarea 
                            placeholder='დამატებითი კომენტარი' 
                            className={css.textarea}  
                            value={newRate.comment_satisfied}
                            onChange={(e) => setNewRate(prevState => ({ ...prevState, comment_satisfied: e.target.value }))}
                        />
                        {validates.comment_satisfied && <div className={css.errorMsg}>{validates.comment_satisfied.message}</div>}
                    </div>        
                    <div>
                        <div className={css.question}>
                            რომელი წყაროდან გაიგო ჩვენ შესასხებ? <span className={css.errorMsg}>*</span>
                            {validates.sourceCheck && <div className={css.errorMsg}>{validates.sourceCheck.message}</div>}
                        </div> 
                        <div className={css.sourceCheck}>
                            <div className={`${css.row} ${css.btween}`}>
                                <div className={css.colAuto}>
                                    <div>
                                        <div className={css.formCheck}>  
                                            <input
                                                type="checkbox"
                                                id="facebook"  
                                                value={1}
                                                checked={newRate.facebook === 1}
                                                onChange={() => setNewRate(prevState => ({ ...prevState, facebook: prevState.facebook === 1 ? 0 : 1 }))}
                                            />
                                            <label htmlFor="facebook">Facebook</label>
                                        </div>  
                                        <div className={css.formCheck}>  
                                            <input
                                                type="checkbox"
                                                id="instagram"  
                                                value={1}
                                                checked={newRate.instagram === 1}
                                                onChange={() => setNewRate(prevState => ({ ...prevState, instagram: prevState.instagram === 1 ? 0 : 1 }))}
                                            />
                                            <label htmlFor="instagram">Instagram</label>
                                        </div>  
                                        <div className={css.formCheck}>  
                                            <input
                                                type="checkbox"
                                                id="tiktok"  
                                                value={1}
                                                checked={newRate.tiktok === 1}
                                                onChange={() => setNewRate(prevState => ({ ...prevState, tiktok: prevState.tiktok === 1 ? 0 : 1 }))}
                                            />
                                            <label htmlFor="tiktok">Tiktok</label>
                                        </div>  
                                        <div className={css.formCheck}>  
                                            <input
                                                type="checkbox"
                                                id="youtube"  
                                                value={1}
                                                checked={newRate.youtube === 1}
                                                onChange={() => setNewRate(prevState => ({ ...prevState, youtube: prevState.youtube === 1 ? 0 : 1 }))}
                                            />
                                            <label htmlFor="youtube">Youtube</label>
                                        </div>  
                                    </div>
                                </div>
                                <div className={css.colAuto}>
                                    <div className={css.formCheck}> 
                                        <input
                                            type="checkbox"
                                            id="google"  
                                            value={1}
                                            checked={newRate.google === 1}
                                            onChange={() => setNewRate(prevState => ({ ...prevState, google: prevState.google === 1 ? 0 : 1 }))}
                                        />
                                        <label htmlFor="google">Google საძიებო</label>
                                    </div> 
                                </div>
                                <div className={css.colAuto}>
                                    <div className={css.formCheck}> 
                                        <input
                                            type="checkbox"
                                            id="autowini"  
                                            value={1}
                                            checked={newRate.autowini === 1}
                                            onChange={() => setNewRate(prevState => ({ ...prevState, autowini: prevState.autowini === 1 ? 0 : 1 }))}
                                        />
                                        <label htmlFor="autowini">autowini</label>
                                    </div> 
                                </div>
                                <div className={css.colAuto} style={{ maxWidth: '128px' }}>
                                    <div className={css.formCheck}> 
                                        <input
                                            type="checkbox"
                                            id="recommendation"  
                                            value={1}
                                            checked={newRate.recommendation === 1}
                                            onChange={() => setNewRate(prevState => ({ ...prevState, recommendation: prevState.recommendation === 1 ? 0 : 1 }))}
                                        />
                                        <label htmlFor="recommendation">რეკომენდაცია</label>
                                    </div> 
                                    {newRate.recommendation === 1 && (
                                        <div className={css.groupInput} style={{ marginTop: '10px' }}>  
                                            <input 
                                                type="text"
                                                className={css.input}
                                                placeholder='სახელი გვარი'
                                                name="recommendation_name" 
                                                value={newRate.recommendation_name} 
                                                autoComplete="off" 
                                                style={{ padding: '0 5px'}}
                                                onChange={(e) => setNewRate(prevState => ({ ...prevState, recommendation_name: e.target.value }))}
                                            />
                                        </div>
                                    )}
                                </div> 
                                <div className={css.colAuto}>
                                    <div className={css.formCheck}> 
                                        <input
                                            type="checkbox"
                                            id="old_client"  
                                            value={1}
                                            checked={newRate.old_client === 1}
                                            onChange={() => setNewRate(prevState => ({ ...prevState, old_client: prevState.old_client === 1 ? 0 : 1 }))}
                                        />
                                        <label htmlFor="old_client">ძველი კლინეტი</label>
                                    </div> 
                                </div> 
                                <div className={css.colAuto}>
                                    <div className={css.formCheck}> 
                                        <input
                                            type="checkbox"
                                            id="outdoor_ad"  
                                            value={1}
                                            checked={newRate.outdoor_ad === 1}
                                            onChange={() => setNewRate(prevState => ({ ...prevState, outdoor_ad: prevState.outdoor_ad === 1 ? 0 : 1 }))}
                                        />
                                        <label htmlFor="outdoor_ad">გარე რეკლამა</label>
                                    </div> 
                                </div> 
                            </div>
                        </div>
                        <div style={{ marginTop: '20px' }} className={css.groupInput}>  
                            <textarea 
                                placeholder='დამატებითი კომენტარი' 
                                className={css.textarea} 
                                value={newRate.additional}
                                onChange={(e) => setNewRate(prevState => ({ ...prevState, additional: e.target.value }))}
                            ></textarea>
                        </div> 
                    </div>

                    <div style={{ display: 'flex', gap: 20, alignItems: 'center' }}>

                        <span onClick={saveHandleRate} className={css.btnPrimary}>შენახვა</span>
                        {oldRate.last_user && (
                            <div className={css.lastUpddated}>
                                გაანახლა - {oldRate.last_user.firstname + ' ' + oldRate.last_user.lastname} -  {formatDate(oldRate.updated_at)} 
                            </div>
                        )}

                    </div>
 
                </div>
            </div>

            <div className={css.bodyPage}>
                <div className={css.container}>
                    <h3 className={css.h3}>მომსახურების შეფასება</h3>

                    <div className={ css.row }>
                        <div className={ css.col2 }>
 
                            <div className={css.groupInput}>  
                                <div className={css.question}> რამდენად კმაყოფილია შენაძენით?  <span className={css.errorMsg}>*</span>
                                    {validates.service_is_satisfied && <div className={css.errorMsg}>{validates.service_is_satisfied.message}</div>}
                                </div>
                                <div className={css.flexforCheck}> 
                                    <div className={css.formCheck}> 
                                        <input
                                            type="radio"
                                            id="ServiceSatisfiedYes"  
                                            value={1}
                                            checked={newService.service_is_satisfied === 1}
                                            onChange={() => setNewService(prevState => ({ ...prevState, service_is_satisfied: 1 }))}
                                        />
                                        <label htmlFor="ServiceSatisfiedYes">კმაყოფილია</label>
                                    </div> 
                                    <div className={css.formCheck}> 
                                        <input
                                            type="radio"
                                            id="ServiceSatisfiedNo"  
                                            value={2}
                                            checked={newService.service_is_satisfied === 2}
                                            onChange={() => setNewService(prevState => ({ ...prevState, service_is_satisfied: 2 }))}
                                        />
                                        <label htmlFor="ServiceSatisfiedNo">არ არის კმაყოფილი</label>
                                    </div>  
                                </div>
                            </div>                          
                            <div className={css.groupInput}>
                                <textarea 
                                    placeholder='დამატებითი კომენტარი' 
                                    className={css.textarea}  
                                    value={newService.service_comment}
                                    onChange={(e) => setNewService(prevState => ({ ...prevState, service_comment: e.target.value }))}
                                />
                                {validates.service_comment && <div className={css.errorMsg}>{validates.service_comment.message}</div>}
                            </div>
 
                        </div>
                        <div className={ css.col2 }>
 
                            <div className={css.groupInput}>  
                                <div className={css.question}> რამდენად კმაყოფილია ფოთის ოფისის მომსახურებით? <span className={css.errorMsg}>*</span>
                                    {validates.poti_is_satisfied && <div className={css.errorMsg}>{validates.poti_is_satisfied.message}</div>}
                                </div>
                                <div className={css.flexforCheck}> 
                                    <div className={css.formCheck}> 
                                        <input
                                            type="radio"
                                            id="PotiSatisfiedYes"  
                                            value={1}
                                            checked={newService.poti_is_satisfied === 1}
                                            onChange={() => setNewService(prevState => ({ ...prevState, poti_is_satisfied: 1 }))}
                                        />
                                        <label htmlFor="PotiSatisfiedYes">კმაყოფილია</label>
                                    </div> 
                                    <div className={css.formCheck}> 
                                        <input
                                            type="radio"
                                            id="PotiSatisfiedNo"  
                                            value={2}
                                            checked={newService.poti_is_satisfied === 2}
                                            onChange={() => setNewService(prevState => ({ ...prevState, poti_is_satisfied: 2 }))}
                                        />
                                        <label htmlFor="PotiSatisfiedNo">არ არის კმაყოფილი</label>
                                    </div>  
                                </div>
                            </div>                          
                            <div className={css.groupInput}>
                                <textarea 
                                    placeholder='დამატებითი კომენტარი' 
                                    className={css.textarea}  
                                    value={newService.poti_comment}
                                    onChange={(e) => setNewService(prevState => ({ ...prevState, poti_comment: e.target.value }))}
                                />
                                {validates.poti_comment && <div className={css.errorMsg}>{validates.poti_comment.message}</div>}
                            </div>
 
                        </div>
                    </div>
 

                    <div className={css.groupInput}>
                        <div className={css.question}>
                            რის გამოუჯობესებას ისურვებდით? ან რომელიმე სერვისი დამატება ხომ არ იქნებოდა კარგი რაც გააამარტივებს შეძენის პროცესს
                            <span className={css.errorMsg}> * </span>
                        </div>  
                        <textarea 
                            style={{ maxWidth: '100%' }}
                            placeholder='დამატებითი კომენტარი' 
                            className={css.textarea}  
                            value={newService.service_additional}
                            onChange={(e) => setNewService(prevState => ({ ...prevState, service_additional: e.target.value }))}
                        />
                        {validates.service_additional && <div className={css.errorMsg}>{validates.service_additional.message}</div>}
                    </div>

                    <div className={css.groupInput}>  
                        <div className={css.question}> რამდენად კმაყოფილი ხართ ლოჯისტიკის მენეჯერის მომსახურებით? <span className={css.errorMsg}>*</span>
                            {validates.logistics_manager_is_satisfied && <div className={css.errorMsg}>{validates.logistics_manager_is_satisfied.message}</div>}
                        </div>
                        <div className={css.flexforCheck}> 
                            <div className={css.formCheck}> 
                                <input
                                    type="radio"
                                    id="LogisticsManagerSatisfiedYes"  
                                    value={1}
                                    checked={newService.logistics_manager_is_satisfied === 1}
                                    onChange={() => setNewService(prevState => ({ ...prevState, logistics_manager_is_satisfied: 1 }))}
                                />
                                <label htmlFor="LogisticsManagerSatisfiedYes">კმაყოფილი ვარ</label>
                            </div> 
                            <div className={css.formCheck}> 
                                <input
                                    type="radio"
                                    id="LogisticsManagerSatisfiedNo"  
                                    value={2}
                                    checked={newService.logistics_manager_is_satisfied === 2}
                                    onChange={() => setNewService(prevState => ({ ...prevState, logistics_manager_is_satisfied: 2 }))}
                                />
                                <label htmlFor="LogisticsManagerSatisfiedNo">არ ვარ კმაყოფილი</label>
                            </div>  
                        </div>
                    </div>
                    <div className={css.groupInput}>
                        <textarea 
                            placeholder='დამატებითი კომენტარი' 
                            className={css.textarea}  
                            value={newService.logistics_manager_comment}
                            onChange={(e) => setNewService(prevState => ({ ...prevState, logistics_manager_comment: e.target.value }))}
                        />
                        {validates.logistics_manager_comment && <div className={css.errorMsg}>{validates.logistics_manager_comment.message}</div>}
                    </div>

                    <div className={css.groupInput}>  
                        <div className={css.question}> დაგიკავშირდათ თუ არა GPI ჰოლდინგის წარმომადგენელი მესამე პირის დაზღვევასთან დაკავშირებით? <span className={css.errorMsg}>*</span>
                            {validates.gpi_contacted_about_third_party_insurance && <div className={css.errorMsg}>{validates.gpi_contacted_about_third_party_insurance.message}</div>}
                        </div>
                        <div className={css.flexforCheck}> 
                            <div className={css.formCheck}> 
                                <input
                                    type="radio"
                                    id="GpiContactedThirdPartyInsuranceYes"  
                                    value={1}
                                    checked={newService.gpi_contacted_about_third_party_insurance === 1}
                                    onChange={() => setNewService(prevState => ({ ...prevState, gpi_contacted_about_third_party_insurance: 1 }))}
                                />
                                <label htmlFor="GpiContactedThirdPartyInsuranceYes">დიახ</label>
                            </div> 
                            <div className={css.formCheck}> 
                                <input
                                    type="radio"
                                    id="GpiContactedThirdPartyInsuranceNo"  
                                    value={2}
                                    checked={newService.gpi_contacted_about_third_party_insurance === 2}
                                    onChange={() => setNewService(prevState => ({ ...prevState, gpi_contacted_about_third_party_insurance: 2 }))}
                                />
                                <label htmlFor="GpiContactedThirdPartyInsuranceNo">არა</label>
                            </div>  
                        </div>
                    </div>

 

                    <div className={css.groupInput}>  
                        <div className={css.question}> გაგზავნილია შეფასების ლინკი
                            
                        </div>
                        <div className={css.formCheck}>  
                                <input
                                    type="checkbox"
                                    id="sent_message"  
                                    value={1}
                                    checked={newService.sent_message === 1}
                                    onChange={() => setNewService(prevState => ({ ...prevState, sent_message: prevState.sent_message === 1 ? 0 : 1 }))}
                                />
                                <label htmlFor="sent_message">
                                    გაგზავნილია შეფასების ლინკი <span className={css.errorMsg}>*</span>
                                {validates.sent_message && <span className={css.errorMsg}>{validates.sent_message.message}</span>}
                                </label>
                            </div>  

                        <div className={css.flexforCheck}>

                            <div className={css.formCheck}>  
                                <input
                                    type="checkbox"
                                    id="send_facebook"  
                                    value={1}
                                    checked={newService.send_facebook === 1}
                                    onChange={() => setNewService(prevState => ({ ...prevState, send_facebook: prevState.send_facebook === 1 ? 0 : 1 }))}
                                />
                                <label htmlFor="send_facebook">facebook</label>
                            </div>  
                            <div className={css.formCheck}>  
                                <input
                                    type="checkbox"
                                    id="send_google"  
                                    value={1}
                                    checked={newService.send_google === 1}
                                    onChange={() => setNewService(prevState => ({ ...prevState, send_google: prevState.send_google === 1 ? 0 : 1 }))}
                                />
                                <label htmlFor="send_google">google</label>
                            </div>
                        </div>
                    </div>                          
 
 
                    <div style={{ display: 'flex', gap: 20, alignItems: 'center' }}>

                    <span onClick={saveHandleService} className={css.btnPrimary}>შენახვა</span>

                    {oldRate.last_user_service && (
                        <div className={css.lastUpddated}>
                        გაანახლა - {oldRate.last_user_service ? oldRate.last_user_service.firstname +' ' + oldRate.last_user_service.lastname : 'Loading...'} - {formatDate(oldRate.service_updated_at)} 
                        </div>
                        )}
 

                    </div>

                </div>
            </div>
            </div>
        </div>
    );
};

export default CarRate;
